import { SendDeviceTokenInterface } from '@actassa/api';

export class SetAwaitingDeviceToken {
    public static readonly type = '[RootState] Set awaiting device token';

    constructor(public payload: SendDeviceTokenInterface) { }
}
